document.addEventListener('DOMContentLoaded', function () {
  const wrapperTitle = document.querySelectorAll('.kom-wrapper-title:not(.mobile)');
  const wrapperContent = document.querySelectorAll('.kom-wrapper-content-text:not(.mobile)');
  const wrapperTitleMobile = document.querySelectorAll('.kom-wrapper-title.mobile');
  const wrapperContentMobile = document.querySelectorAll('.kom-wrapper-content-text.mobile');
  const ancorLink = document.querySelectorAll('.kom-recensioni-ancora');

  function activateTab(index) {
    [wrapperTitle, wrapperTitleMobile].forEach(titles => {
      titles.forEach(title => title.classList.remove('kom-active'));
      if (titles[index]) titles[index].classList.add('kom-active');
    });
    [wrapperContent, wrapperContentMobile].forEach(contents => {
      contents.forEach(content => content.classList.remove('kom-active'));
      if (contents[index]) contents[index].classList.add('kom-active');
    });
  }

  wrapperTitle.forEach((title, index) => {
    title.addEventListener('click', () => activateTab(index));
  });

  wrapperTitleMobile.forEach((title, index) => {
    title.addEventListener('click', () => activateTab(index));
  });

  ancorLink.forEach((link) => {
    link.addEventListener('click', () => {
      const recensioniIndex = Array.from(wrapperTitle).findIndex(title => title.textContent.trim().toLowerCase() === 'recensioni');
      if (recensioniIndex !== -1) {
        activateTab(recensioniIndex);
      }
    });
  });
});
  function copyUrlToClipboard() {
    // Recupera l'URL della pagina corrente
    const currentUrl = window.location.href;
    
    // Usa l'API clipboard di navigator, se disponibile
    navigator.clipboard.writeText(currentUrl)
      .then(() => {
        // Facoltativo: mostra un messaggio di conferma
        alert("URL copiato negli appunti!");
      })
      .catch(err => {
        console.error("Errore nella copia negli appunti", err);
      }); 
  }; 

// document.addEventListener("DOMContentLoaded", function () {
//   const toggleButton = document.getElementById("toggleShortDescription");
//   const shortDescription = document.getElementById("shortDescription");

//   toggleButton.addEventListener("click", function () {
//     if (shortDescription.style.display === "none" || shortDescription.style.display === "") {
//       shortDescription.style.display = "block";
//       toggleButton.textContent = "Nascondi descrizione";
//     } else {
//       shortDescription.style.display = "none";
//       toggleButton.textContent = "Mostra descrizione";
//     }
//   });
// });

/* OMAGGI - foto del prodotto in regalo + classe per la grafica (27/07/2026).
   Legge l'handle dal link dell'app Discount Ninja, chiede a Shopify la foto
   principale e la mette a sinistra nel riquadro. La grafica sta in
   assets/kom-product-page.css. */

(function () {
  var cache = {};

  function fotoProdotto(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.featured_image ? p.featured_image : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function sistemaOmaggi() {
    var links = document.querySelectorAll('.limoniapps-discountninja-promotioncard-productpage a.limoniapps-targetlink');

    for (var n = 0; n < links.length; n++) {
      (function (a) {
        var card = a.closest('.limoniapps-discountninja-promotioncard-productpage');
        if (!card || card.dataset.cfsOmaggio) return;

        var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
        if (!m) return;

        card.dataset.cfsOmaggio = '1';
        card.classList.add('cfs-omaggio-card');

        fotoProdotto(m[1]).then(function (src) {
          if (!src) return;

          var box = document.createElement('a');
          box.className = 'cfs-omaggio-foto';
          box.href = a.getAttribute('href');
          box.setAttribute('aria-hidden', 'true');
          box.tabIndex = -1;

          var img = document.createElement('img');
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
          img.alt = '';
          img.loading = 'lazy';

          box.appendChild(img);
          card.insertBefore(box, card.firstChild);
        });
      })(links[n]);
    }
  }

  sistemaOmaggi();

  var attesa;
  new MutationObserver(function () {
    clearTimeout(attesa);
    attesa = setTimeout(sistemaOmaggi, 80);
  }).observe(document.body, { childList: true, subtree: true });
})();